import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/app/App'
import reportWebVitals from './reportWebVitals';
import Footer from './components/footer/Footer';

import 'materialize-css/dist/css/materialize.min.css';
import 'weathericons/css/weather-icons.min.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <App />
      <Footer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
